import { REGEX_URL } from 'clickNgo/configs/regex'

export const checkURL = async (value: string): Promise<string> => {
  if (!value.length) {
    return ''
  }

  return !REGEX_URL.test(value) ? 'Incorrect value. Example: "google.com"' : ''
}
